/*@ngInject*/
const FormRepository = function (baseRepository, formRegistrationModel) {

    angular.extend(this, baseRepository);

    this.getFormsByRootFormId = function (rootFormId) {
        let url = '/rest/Form/' + rootFormId + '/List?registrationIdentifier=RootFormList_' + rootFormId;

        formRegistrationModel.addRegistration(rootFormId, '/rest/Form/List?registrationIdentifier=RootFormList_' + rootFormId);

        return this.get(url);
    };

    this.resetRequiredFieldCountByFormId = function (rootFormId) {
        let url = '/rest/Form/' + rootFormId + '/resetRequiredFieldCount';
        return this.post(url);
    };
};

angular.module('umFormViewer')
    .service('formRepository', FormRepository);
